// @flow
import PATHS, { HOUSEHOLD_PATHS } from 'constants/paths';
import { SectionSteps } from 'hooks/sectionsProgress/types';
import { FormattedMessage } from 'react-intl';

export const BUTTON_GROUP_SX = {
  flexWrap: 'wrap',
  width: '100%',
  '& > button': {
    width: { xs: 'calc(100% - 4px)', sm: 'calc(50% - 4px)' },
  },
};

export const ADDITIONAL_MINORS_FIELD_NAMES = {
  EXPECTING_MINORS_TYPE: 'expectingMinorsType',
  PREGNANCY: 'pregnancy',
  PREGNANCY_COUNT: 'pregnancyCount',
  PREGNANCY_DUE_DATE: 'pregnancyDueDate',
  ADOPTION: 'adoption',
  ADOPTION_COUNT: 'adoptionCount',
  ANTICIPATED_ADOPTION_DATE: 'anticipatedAdoptionDate',
  GUARDIANSHIP: 'guardianship',
  GUARDIANSHIP_COUNT: 'guardianshipCount',
  ANTICIPATED_GUARDIANSHIP_START_DATE: 'anticipatedGuardianshipStartDate',
  NOT_APPLICABLE: 'notApplicable',
};

export const JOINT_CUSTODY_MAP = {
  no: {
    messageId: 'app.no',
    text: <FormattedMessage id="app.no" />,
    value: 'no',
  },
  yes50: {
    messageId: 'afforda.minorsRelationships.jointCustody.yes50',
    text: (
      <FormattedMessage id="afforda.minorsRelationships.jointCustody.yes50" />
    ),
    value: 'yes50',
  },
  yesLessThan50: {
    messageId: 'afforda.minorsRelationships.jointCustody.yesLessThan50',
    text: (
      <FormattedMessage id="afforda.minorsRelationships.jointCustody.yesLessThan50" />
    ),
    value: 'yesLessThan50',
  },
};
export const JOINT_CUSTODY_OPTIONS = [
  JOINT_CUSTODY_MAP.no,
  JOINT_CUSTODY_MAP.yes50,
  JOINT_CUSTODY_MAP.yesLessThan50,
];

export const HOUSEHOLD_STEPS = ({
  hasMoreThanOneAdult,
  hasMinors,
  hasPartTimeStudent,
  isStudentDisqualified,
}): SectionSteps => [
  {
    name: HOUSEHOLD_PATHS.MEMBERS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.MEMBERS}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.DESIGNATION,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.DESIGNATION}`,
    required: hasMoreThanOneAdult,
  },
  {
    name: HOUSEHOLD_PATHS.MARITAL_STATUS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.MARITAL_STATUS}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.MINOR_RELATIONSHIP,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.MINOR_RELATIONSHIP}`,
    required: hasMinors,
  },
  {
    name: HOUSEHOLD_PATHS.STUDENT_STATUS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.STUDENT_STATUS}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.FULL_TIME_STUDENT,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.FULL_TIME_STUDENT}`,
    required: !hasPartTimeStudent,
  }, // Only required if there are NO part-time students
  {
    name: HOUSEHOLD_PATHS.ADDITIONAL_MINORS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.ADDITIONAL_MINORS}`,
    required: hasPartTimeStudent || isStudentDisqualified,
  },
  {
    name: HOUSEHOLD_PATHS.SUMMARY,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.SUMMARY}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.INVITE,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.INVITE}`,
    required: hasMoreThanOneAdult,
  },
];
